export default __webpack_public_path__ + "static/media/copy2clipboard.859ab7ec.svg";